// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"4d2db86a","870":"4d2db86a","2255":"3b1e880a","4621":"4d2db86a","5081":"4d2db86a","9238":"3b1e880a"}[chunkId] + ".chunk.css";
};